import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            uio: number
        }
    }
}

export default class Wait extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        if (!message) {
            return (
                <div>
                    <p>
                        We observed Traces with significant unaccounted CPU wait time. This could either be I/O by a library or PHP
                        extension that Tideways doesn&apos;t instrument or caused by high load on the server that lets PHP requests wait for
                        CPU for a long time.
                    </p>
                </div>
            )
        }

        const { args } = message

        return (
            <div>
                <p>
                    This trace has <Milliseconds value={args.uio} /> of unaccounted CPU wait time. This could either be I/O by a library or
                    PHP extension that Tideways doesn&apos;t instrument or caused by high load on the server that lets PHP requests wait for
                    CPU for a long time.
                </p>
            </div>
        )
    }
}
